import { sb } from "@/lib/sb";

export async function isAdmin(userId: string): Promise<boolean> {
  const { data } = await sb
    .from("admin_users")
    .select("user_id")
    .eq("user_id", userId)
    .maybeSingle();
  return !!data;
}

/**
 * Log a sign-in attempt. `success=true` → event_type 'login_success',
 * otherwise 'login_failed'. The original sub-reason (e.g. 'otp_failed',
 * 'oauth_unauthorized') is stored in details.reason so the dashboard counts
 * still work but a finer breakdown is preserved.
 */
export async function logSecurityEvent(
  reason: string,
  success: boolean,
  email_attempted?: string | null,
) {
  try {
    const event_type = success ? "login_success" : "login_failed";
    await sb.from("security_events").insert({
      event_type,
      success,
      email_attempted: email_attempted ?? null,
      severity: success ? "info" : "warn",
      details: {
        reason,
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
      },
    });
  } catch {
    /* non-blocking */
  }
}
